// saga.ts
import { call, put, takeEvery } from 'redux-saga/effects';
import {
    createCollections,
    deleteCollections,
    getCollectionsApi,
    getCollectionsReportApi,
    getCollectionsUsersReportApi,
    updateCollections,
} from '../../api/CollectionsApi'; // Adjust the path as needed
import {
    getCollectionsSuccess,
    getCollectionsFailure,
    createCollectionsSuccess,
    createCollectionsFailure,
    updateCollectionsSuccess,
    updateCollectionsFailure,
    deleteCollectionsSuccess,
    deleteCollectionsFailure,
    getCollectionsReportSuccess,
    getCollectionsReportFailure,
    getCollectionsUserReportFailure,
    getCollectionsUserReportSuccess,
} from './actions';

// Saga to handle fetching Collectionss
function* fetchCollectionsSaga(action: any): Generator<any, any, any> {
    try {
        const data = yield call(getCollectionsApi, action.payload);
        yield put(getCollectionsSuccess(data));
    } catch (error: any) {
        const errorMessage = error?.response?.data?.meta?.message
            ? error.response
            : error?.message
                ? error.message
                : 'An unexpected error occurred';

        yield put(getCollectionsFailure(errorMessage));
    }
}

function* fetchCollectionsReportSaga(action: any): Generator<any, any, any> {
    try {
        const data = yield call(getCollectionsReportApi, action.payload);
        yield put(getCollectionsReportSuccess(data));
    } catch (error: any) {
        const errorMessage = error?.response?.data?.meta?.message
            ? error.response
            : error?.message
                ? error.message
                : 'An unexpected error occurred';

        yield put(getCollectionsReportFailure(errorMessage));
    }
}

function* fetchCollectionsUserReportSaga(action: any): Generator<any, any, any> {
    try {
        const data = yield call(getCollectionsUsersReportApi, action.payload);
        yield put(getCollectionsUserReportSuccess(data));
    } catch (error: any) {
        const errorMessage = error?.response?.data?.meta?.message
            ? error.response
            : error?.message
                ? error.message
                : 'An unexpected error occurred';

        yield put(getCollectionsUserReportFailure(errorMessage));
    }
}

// // Saga to handle creating a Collections
function* createCollectionsSaga(action: any): Generator<any, any, any> {
    try {
        const data = yield call(createCollections, action.payload);
        yield put(createCollectionsSuccess(data));
    } catch (error: any) {
        const errorMessage = error?.response?.data?.meta?.message
            ? error.response
            : error?.message
                ? error.message
                : 'An unexpected error occurred';

        yield put(createCollectionsFailure(errorMessage));
    }
}

// // Saga to handle updating a Collections
function* updateCollectionsSaga(action: any): Generator<any, any, any> {
    try {
        const data = yield call(updateCollections, action.payload.data, action.payload.id);
        yield put(updateCollectionsSuccess(data));
    } catch (error: any) {
        const errorMessage = error?.response?.data?.meta?.message
            ? error.response
            : error?.message
                ? error.message
                : 'An unexpected error occurred';

        yield put(updateCollectionsFailure(errorMessage));
    }
}

// // Saga to handle updating a Collections
function* deleteCollectionsSaga(action: any): Generator<any, any, any> {
    try {
        const data = yield call(deleteCollections, action.payload.id);
        yield put(deleteCollectionsSuccess(data));
    } catch (error: any) {
        yield put(deleteCollectionsFailure(error.message));
    }
}

export default function* CollectionsSaga() {
    yield takeEvery('GET_COLLECTIONS_REQUEST', fetchCollectionsSaga);
    yield takeEvery('GET_COLLECTIONS_REPORT_REQUEST', fetchCollectionsReportSaga);
    yield takeEvery('GET_COLLECTIONS_USER_REPORT_REQUEST', fetchCollectionsUserReportSaga);
    yield takeEvery('CREATE_COLLECTIONS_REQUEST', createCollectionsSaga);
    yield takeEvery('UPDATE_COLLECTIONS_REQUEST', updateCollectionsSaga);
    yield takeEvery('DELETE_COLLECTIONS_REQUEST', deleteCollectionsSaga);
}
